<script>
export default {
    name: "Partners",
    methods: {
        openLink(link) {
            if (link) {
                window.open(link, '_blank')
            } else {
                console.error('Нет ссылки')
            }
        }
    },
}
</script>

<template>
<section class="partners">
    <h2>{{__('С Cloud Mods уже играют')}}</h2>
    <section class="partners-container">
        <div class="partner-card" @click="openLink('https://www.youtube.com/@etnaisegod')">
            <div class="media-avtr-container">
                <img src="@/assets/images/media/etnaise.jpg" class="media-avtr">
                <img src="@/assets/icons/yt.svg" class="yt">
            </div>
            <div class="partners-title-container">
                <div class="prtns-title-container">
                    <div class="prtns-title">Etnaise</div>
                </div>
                <div class="prtns-subs">60 {{__('тыс.')}} {{__('подписчиков')}}</div>
            </div>
        </div>
        <div class="partner-card" @click="openLink('https://twitch.tv/wholezy')">
            <div class="media-avtr-container">
                <img src="@/assets/images/media/Whole.jpg" class="media-avtr">
                <img src="@/assets/icons/twitch.svg" class="yt">
            </div>
            <div class="partners-title-container">
                <div class="prtns-title-container">
                    <div class="prtns-title">Whole</div>
                </div>
                <div class="prtns-subs">13.2 {{__('тыс.')}} {{__('подписчиков')}}</div>
            </div>
        </div>
        <div class="partner-card" @click="openLink('https://www.youtube.com/@Merchik')">
            <div class="media-avtr-container">
                <img src="@/assets/images/media/Merchik.jpg" class="media-avtr">
                <img src="@/assets/icons/yt.svg" class="yt">
            </div>
            <div class="partners-title-container">
                <div class="prtns-title-container">
                    <div class="prtns-title">Merchik</div>
                </div>
                <div class="prtns-subs">642 {{__('тыс.')}} {{__('подписчиков')}}</div>
            </div>
        </div>
        <div class="partner-card" @click="openLink('https://www.twitch.tv/meetenshow')">
            <div class="media-avtr-container">
                <img src="@/assets/images/media/meteen.jpg" class="media-avtr">
                <img src="@/assets/icons/twitch.svg" class="yt">
            </div>
            <div class="partners-title-container">
                <div class="prtns-title-container">
                    <div class="prtns-title">Meeten Show</div>
                </div>
                <div class="prtns-subs">44,4 {{__('тыс.')}} {{__('подписчиков')}}</div>
            </div>
        </div>
    </section>
    <section class="partners-container mobile">
        <div class="partner-card" @click="openLink('https://www.youtube.com/@etnaisegod')">
            <div class="media-avtr-container">
                <img src="@/assets/images/media/etnaise.jpg" class="media-avtr">
                <img src="@/assets/icons/yt.svg" class="yt">
            </div>
            <div class="partners-title-container">
                <div class="prtns-title-container">
                    <div class="prtns-title">Etnaise</div>
                </div>
                <div class="prtns-subs">60 {{__('тыс.')}} {{__('подписчиков')}}</div>
            </div>
        </div>
        <div class="partner-card" @click="openLink('https://twitch.tv/wholezy')">
            <div class="media-avtr-container">
                <img src="@/assets/images/media/Whole.jpg" class="media-avtr">
                <img src="@/assets/icons/twitch.svg" class="yt">
            </div>
            <div class="partners-title-container">
                <div class="prtns-title-container">
                    <div class="prtns-title">Whole</div>
                </div>
                <div class="prtns-subs">13.2 {{__('тыс.')}} {{__('подписчиков')}}</div>
            </div>
        </div>
        <div class="partner-card" @click="openLink('https://www.youtube.com/@Merchik')">
            <div class="media-avtr-container">
                <img src="@/assets/images/media/Merchik.jpg" class="media-avtr">
                <img src="@/assets/icons/yt.svg" class="yt">
            </div>
            <div class="partners-title-container">
                <div class="prtns-title-container">
                    <div class="prtns-title">Merchik</div>
                </div>
                <div class="prtns-subs">642 {{__('тыс.')}} {{__('подписчиков')}}</div>
            </div>
        </div>
        <div class="partner-card" @click="openLink('https://www.twitch.tv/meetenshow')">
            <div class="media-avtr-container">
                <img src="@/assets/images/media/meteen.jpg" class="media-avtr">
                <img src="@/assets/icons/twitch.svg" class="yt">
            </div>
            <div class="partners-title-container">
                <div class="prtns-title-container">
                    <div class="prtns-title">Meeten Show</div>
                </div>
                <div class="prtns-subs">44,4 {{__('тыс.')}} {{__('подписчиков')}}</div>
            </div>
        </div>
    </section>
</section>
</template>

<style>
    .partners {
            width: 100%;

            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            background-repeat: no-repeat;
            background-position: center;
    }


    h2 {
        color: var(--text-primary);
        margin: 0;
        font-style: normal;
        font-weight: 600;
    }

    .partners-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .partners-container.mobile {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .partner-card {
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #040404;
        border: 1px solid rgba(255, 255, 255, 0.10);
        transition: 0.25s ease;
    }

    .partner-card:hover {
        cursor: pointer;
        background: var(--bg-secondary);
    }

    .partners-title-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .prtns-title {
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-align: center;
        color: var(--text-primary);
    }

    .prtns-subs {
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-align: center;
        color: var(--text-secondary);
    }

    .prtns-title-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
    }

    .media-avtr-container {
        display: flex;
        flex-direction: column;
        align-items: center;

        position: relative;
    }

    .yt {
        position: absolute;
    }

    @media (min-width: 320px) {
        .partners-container {
            display: none;
        }

        .partners {
            height: 77.8125vw;
            gap: 5vw;
            background-image: url("@/assets/images/partners1244.png");
        }

        h2 {
            width: 90vw;
            text-align: left;
            font-size: 6.25vw;
        }

        .partners-container {
            gap: 3.125vw;
        }

        .partners-container.mobile {
            overflow-x: scroll;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            margin-left: 10vw;
            width: 100%;
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            overflow: -moz-scrollbars-none;
        }

        .partners-container::-webkit-scrollbar {
            overflow-x: scroll;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            margin-left: 10vw;
            width: 100%;
        }

        .partner-card {
            flex-shrink: 0;
            width: 56.25vw;
            height: 55.3125vw;
            gap: 3.125vw;
            border-radius: 3.75vw;

            background-size: cover;
            background-image: url("@/assets/images/partners_blur.png");
        }

        .media-avtr {
            border-radius: 50%;
            width: 26.25vw;
            height: 26.25vw;
        }

        .partners-title-container {
            gap: 0.625vw;
        }

        .prtns-title {
            font-size: 4.6875vw;
        }

        .prtns-subs {
            font-size: 4.0625vw;
        }

        .prtns-title-container {
            gap: 0.625vw;
        }

        .yt {
            bottom: -12%;
            height: 7.375vw;
        }
    }

    @media (min-width: 464px) {
        .partners {
            height: 271px;
            gap: 26px;
            background-image: url("@/assets/images/partners1244.png");
        }

        h2 {
            width: auto;
            text-align: center;
            font-size: 20px;
        }

        .partners-container {
            gap: 12px;
        }

        .partners-container.mobile {
            overflow-x: scroll;
            display: flex;
            align-items: center;
            justify-content: center;
            width: auto;
            margin-left: 0vw;
            gap: 12px;
        }

        .partner-card {
            width: 147px;
            height: 183px;
            gap: 16px;
            border-radius: 12px;

            background-size: cover;
            background-image: url("@/assets/images/partners_blur.png");
        }

        .media-avtr {
            border-radius: 50%;
            width: 84px;
            height: 84px;
        }

        .partners-title-container {
            gap: 3px;
        }

        .prtns-title {
            font-size: 14px;
        }

        .prtns-subs {
            font-size: 12px;
        }

        .prtns-title-container {
            gap: 2px;
        }

        .yt {
            bottom: -12%;
            height: 30px;
        }
    }

    @media (min-width: 744px) {
        .partners-container.mobile {
            display: none;
        }

        .partners-container {
            display: flex;
        }

        .partners {
            height: 318px;
            gap: 24px;
            background-image: url("@/assets/images/partners1244.png");
        }

        h2 {
            font-size: 26px;
        }

        .partners-container {
            gap: 12px;
        }

        .partner-card {
            width: 177px;
            height: 207px;
            gap: 16px;
            border-radius: 12px;

            background-size: cover;
            background-image: url("@/assets/images/partners_blur.png");
        }

        .media-avtr {
            border-radius: 50%;
            width: 84px;
            height: 84px;
        }

        .partners-title-container {
            gap: 3px;
        }

        .prtns-title {
            font-size: 16px;
        }

        .prtns-subs {
            font-size: 14px;
        }

        .prtns-title-container {
            gap: 8px;
        }

        .yt {
            bottom: -6%;
            height: 30px;
        }
    }

    @media (min-width: 984px) {
        .partners {
            height: 439px;
            gap: 32px;
            background-image: url("@/assets/images/partners1244.png");
        }

        h2 {
            font-size: 32px;
        }

        .partners-container {
            gap: 12px;
        }

        .partner-card {
            width: 237px;
            height: 233px;
            gap: 16px;
            border-radius: 12px;

            background-image: url("@/assets/images/partners_blur.png");
        }

        .media-avtr {
            border-radius: 50%;
            width: 106px;
            height: 106px;
        }

        .partners-title-container {
            gap: 3px;
        }

        .prtns-title {
            font-size: 20px;
        }

        .prtns-subs {
            font-size: 16px;
        }

        .prtns-title-container {
            gap: 8px;
        }

        .yt {
            bottom: -10%;
            height: 30px;
        }
    }

    @media (min-width: 1248px) {
        .partners {
            height: 439px;
            gap: 32px;
            background-image: url("@/assets/images/partners1244.png");
        }

        h2 {
            font-size: 32px;
        }

        .partners-container {
            gap: 12px;
        }

        .partner-card {
            width: 303px;
            height: 249px;
            gap: 16px;
            border-radius: 12px;

            background-image: url("@/assets/images/partners_blur.png");
        }

        .media-avtr {
            border-radius: 50%;
            width: 106px;
            height: 106px;
        }

        .partners-title-container {
            gap: 3px;
        }

        .prtns-title {
            font-size: 20px;
        }

        .prtns-subs {
            font-size: 16px;
        }

        .prtns-title-container {
            gap: 8px;
        }

        .yt {
            height: 30px;
        }
    }
</style>